
export interface ExpirationConfiguration {
    disabled: boolean;
    deleteFrequencyInSec: number;
}